<template>
  <multiselect
    v-bind="$attrs"
    v-on="forwardListeners"
    v-model="completeValue"
    :options="Array.isArray(options) ? [...options].filter(option => option) : []"
    :track-by="trackBy"
    :label="label"
    :disabled="disabled"
    :hide-selected="false"
  >
    <!-- Expose ALL slots from the third-part component into our custom wrapper -->
    <template v-for="(_, name) in $scopedSlots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}"/>
    </template>
  </multiselect>
</template>
<script>
import Multiselect from 'vue-multiselect'

export default {
  inheritAttrs: false,
  components: {
    Multiselect
  },
  props: ['value', 'options', 'trackBy', 'label', 'disabled'],
  computed: {
    completeValue: {
      get() {
        return this.$attrs.multiple
          ? this.value ? this.value.map(value => this.findOption(value)) : null
          : this.findOption(this.value)
      },
      set(v) {
        this.$emit('input', this.$attrs.multiple
          ? v.map(value => value[this.trackBy])
          : (v && v[this.trackBy]))
      }
    },
    forwardListeners() {
      const { input, ...listeners } = this.$listeners
      return listeners
    }
  },
  methods: {
    findOption(value) {
      return this.options
        ? this.options.find(option => option[this.trackBy] === value)
        : null
    }
  }
}
</script>

<style type="text/css">
.highlighted {
  color: #e6b222;
  font-weight: bold;
}
</style>
